module.exports = __webpack_public_path__ + "img/function-icon-square.670a1ef6.svg";